import { render, staticRenderFns } from "./LuogoList.vue?vue&type=template&id=721f06ef&"
import script from "./LuogoList.vue?vue&type=script&lang=ts&"
export * from "./LuogoList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports